import styled from 'styled-components';

const IconWrapper = styled.div`
  display: inline-flex;
  cursor: pointer;
  transition: transform 0.2s ease;
  will-change: transform;
  transform: translateZ(0);
  backface-visibility: hidden;

  --icon-bg: ${({ theme }) => theme.COLORS.SocialIconBg};
  --icon-fg: ${({ theme }) => theme.COLORS.SocialIconFg};

  &:hover {
    transform: scale(1.1) translateZ(0);
  }
`;

export const MusicIcon = () => {
  return (
    <IconWrapper>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.0297 0H14.9614C6.69846 0 0 6.70044 0 14.9658V15.0342C0 23.2996 6.69846 30 14.9614 30H15.0297C23.2927 30 29.9912 23.2996 29.9912 15.0342V14.9658C29.9912 6.70044 23.2927 0 15.0297 0Z"
          fill="var(--icon-bg)"
        />
        <path
          d="M22.2451 10.853V13.6856C21.7502 13.6373 21.1072 13.5248 20.3958 13.2641C19.467 12.9236 18.7756 12.458 18.3227 12.0975V17.8225L18.3112 17.8047C18.3185 17.9182 18.3227 18.0338 18.3227 18.1505C18.3227 20.9935 16.0101 23.3079 13.1668 23.3079C10.3235 23.3079 8.0108 20.9935 8.0108 18.1505C8.0108 15.3074 10.3235 12.9919 13.1668 12.9919C13.4452 12.9919 13.7184 13.014 13.9853 13.0571V15.8487C13.7289 15.7572 13.4536 15.7078 13.1668 15.7078C11.8208 15.7078 10.7249 16.803 10.7249 18.1505C10.7249 19.4979 11.8208 20.5931 13.1668 20.5931C14.5128 20.5931 15.6087 19.4968 15.6087 18.1505C15.6087 18.1 15.6076 18.0496 15.6045 17.9991V6.87378H18.4341C18.4446 7.11342 18.4541 7.35516 18.4646 7.5948C18.4835 8.06672 18.6516 8.51972 18.9448 8.89074C19.2884 9.32692 19.7959 9.83353 20.5083 10.2382C21.1755 10.6155 21.8017 10.7784 22.2451 10.8551V10.853Z"
          fill="var(--icon-fg)"
        />
      </svg>
    </IconWrapper>
  );
};

export const FaceBookIcon = () => {
  return (
    <IconWrapper>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.9979 15.0005C29.9979 22.5765 24.3824 28.8396 17.0873 29.856C16.4052 29.9506 15.7073 30 14.9989 30C14.1813 30 13.3783 29.9348 12.5963 29.8087C5.45474 28.6589 0 22.4661 0 15.0005C0 6.71618 6.71595 0 15 0C23.2841 0 30 6.71618 30 15.0005H29.9979Z"
          fill="var(--icon-bg)"
        />
        <path
          d="M17.0873 12.0449V15.3126H21.1295L20.4894 19.7144H17.0873V29.8559C16.4052 29.9505 15.7074 29.9999 14.999 29.9999C14.1813 29.9999 13.3783 29.9348 12.5964 29.8086V19.7144H8.86844V15.3126H12.5964V11.3144C12.5964 8.83397 14.6069 6.82227 17.0884 6.82227V6.82437C17.0957 6.82437 17.102 6.82227 17.1094 6.82227H21.1306V10.6292H18.503C17.7221 10.6292 17.0884 11.2629 17.0884 12.0439L17.0873 12.0449Z"
          fill="var(--icon-fg)"
        />
      </svg>
    </IconWrapper>
  );
};

export const InstagramIcon = () => {
  return (
    <IconWrapper>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.0342 0H14.9658C6.70044 0 0 6.70044 0 14.9658V15.0342C0 23.2996 6.70044 30 14.9658 30H15.0342C23.2996 30 30 23.2996 30 15.0342V14.9658C30 6.70044 23.2996 0 15.0342 0Z"
          fill="var(--icon-bg)"
        />
        <path
          d="M19.6419 6.10327H10.359C7.79447 6.10327 5.70815 8.1896 5.70815 10.7541V19.2466C5.70815 21.8111 7.79447 23.8975 10.359 23.8975H19.6419C22.2064 23.8975 24.2927 21.8111 24.2927 19.2466V10.7541C24.2927 8.1896 22.2064 6.10327 19.6419 6.10327ZM7.34883 10.7541C7.34883 9.09455 8.69942 7.74395 10.359 7.74395H19.6419C21.3015 7.74395 22.6521 9.09455 22.6521 10.7541V19.2466C22.6521 20.9062 21.3015 22.2568 19.6419 22.2568H10.359C8.69942 22.2568 7.34883 20.9062 7.34883 19.2466V10.7541Z"
          fill="var(--icon-fg)"
        />
        <path
          d="M15.0004 19.3253C17.3852 19.3253 19.3265 17.3851 19.3265 14.9992C19.3265 12.6133 17.3862 10.6731 15.0004 10.6731C12.6145 10.6731 10.6743 12.6133 10.6743 14.9992C10.6743 17.3851 12.6145 19.3253 15.0004 19.3253ZM15.0004 12.3148C16.4813 12.3148 17.6858 13.5193 17.6858 15.0002C17.6858 16.4812 16.4813 17.6857 15.0004 17.6857C13.5194 17.6857 12.3149 16.4812 12.3149 15.0002C12.3149 13.5193 13.5194 12.3148 15.0004 12.3148Z"
          fill="var(--icon-fg)"
        />
        <path
          d="M19.7269 11.3722C20.3691 11.3722 20.8925 10.8499 20.8925 10.2066C20.8925 9.56339 20.3701 9.04102 19.7269 9.04102C19.0836 9.04102 18.5613 9.56339 18.5613 10.2066C18.5613 10.8499 19.0836 11.3722 19.7269 11.3722Z"
          fill="var(--icon-fg)"
        />
      </svg>
    </IconWrapper>
  );
};

export const BotIcon = () => {
  return (
    <IconWrapper>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.9659 0H15.0342C23.2996 0 30 6.70044 30 14.9658V15.0342C30 23.2996 23.2996 30 15.0342 30H14.9659C6.70045 30 0 23.2996 0 15.0342V14.9658C0 6.70044 6.70045 0 14.9659 0Z"
          fill="var(--icon-bg)"
        />
        <path
          d="M5.70524 14.6243C5.95434 13.4944 6.98646 12.7618 8.01018 12.9878C8.35912 13.0645 8.65974 13.2443 8.89728 13.4902C10.2752 12.4896 12.1566 11.8285 14.2576 11.7034L13.2518 7.51606L10.2678 8.22972C10.2184 9.04533 9.54262 9.69172 8.7144 9.69172C7.88617 9.69172 7.15674 8.99383 7.15674 8.13407C7.15674 7.27432 7.85464 6.57642 8.7144 6.57642C9.33767 6.57642 9.87474 6.94323 10.1228 7.47296L13.36 6.69834C13.6144 6.63738 13.8698 6.79398 13.9318 7.04833L15.0448 11.6824C17.3887 11.695 19.5034 12.3729 21.0211 13.4587C21.0957 13.3893 21.1756 13.3252 21.2628 13.2684C22.1467 12.704 23.3681 13.0372 23.9903 14.0115C24.6125 14.9869 24.4012 16.2345 23.5173 16.7989C23.4648 16.8325 23.4112 16.8619 23.3565 16.8893C23.3922 17.1068 23.4112 17.3286 23.4112 17.5525C23.4112 20.795 19.6368 23.4236 14.9807 23.4236C10.3246 23.4236 6.55029 20.795 6.55029 17.5525C6.55029 17.3255 6.57026 17.1016 6.60705 16.8819C5.88918 16.4647 5.49818 15.5555 5.70314 14.6243H5.70524ZM19.3037 16.1924C19.3037 15.4535 18.7046 14.8545 17.9657 14.8545C17.2268 14.8545 16.6277 15.4535 16.6277 16.1924C16.6277 16.9313 17.2268 17.5304 17.9657 17.5304C18.7046 17.5304 19.3037 16.9313 19.3037 16.1924ZM11.8728 20.4166C12.2837 20.7897 13.4189 21.66 15.0806 21.6757C15.0953 21.6757 15.1111 21.6757 15.1258 21.6757C16.8095 21.6757 17.9594 20.7971 18.3788 20.4166C18.5133 20.2947 18.5227 20.0866 18.4008 19.9531C18.2789 19.8185 18.0708 19.8091 17.9373 19.931C17.5726 20.2631 16.5646 21.0336 15.0869 21.0199C13.6501 21.0062 12.6695 20.2547 12.3142 19.9321C12.1797 19.8101 11.9726 19.8196 11.8507 19.9541C11.7288 20.0887 11.7382 20.2957 11.8728 20.4176V20.4166ZM12.0346 17.5304C12.7735 17.5304 13.3726 16.9313 13.3726 16.1924C13.3726 15.4535 12.7735 14.8545 12.0346 14.8545C11.2957 14.8545 10.6967 15.4535 10.6967 16.1924C10.6967 16.9313 11.2957 17.5304 12.0346 17.5304Z"
          fill="var(--icon-fg)"
        />
      </svg>
    </IconWrapper>
  );
};

export const XIcon = () => {
  return (
    <IconWrapper>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.9979 15.0005C29.9979 22.5765 24.3824 28.8396 17.0873 29.856C16.4052 29.9506 15.7073 30 14.9989 30C14.1813 30 13.3783 29.9348 12.5963 29.8087C5.45474 28.6589 0 22.4661 0 15.0005C0 6.71618 6.71595 0 15 0C23.2841 0 30 6.71618 30 15.0005H29.9979Z"
          fill="var(--icon-bg)"
        />
        <path
          d="M6.08327 6.61621L13.001 15.8654L6.04018 23.3856H7.60723L13.702 16.8019L18.626 23.3856H23.9578L16.6512 13.6162L23.1306 6.61621H21.5636L15.9512 12.6797L11.4161 6.61621H6.08431H6.08327ZM8.38708 7.77026H10.8359L21.6519 22.2316H19.203L8.38708 7.77026Z"
          fill="var(--icon-fg)"
        />
      </svg>
    </IconWrapper>
  );
};

export const CallIcon = () => {
  return (
    <IconWrapper>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.0342 0H14.9658C6.70044 0 0 6.70044 0 14.9658V15.0342C0 23.2996 6.70044 30 14.9658 30H15.0342C23.2996 30 30 23.2996 30 15.0342V14.9658C30 6.70044 23.2996 0 15.0342 0Z"
          fill="var(--icon-bg)"
        />
        <path
          d="M17.9235 19.3876C14.084 19.3876 10.9603 16.2629 10.9593 12.4234C10.9603 11.4501 11.7528 10.6587 12.724 10.6587C12.8238 10.6587 12.9226 10.6671 13.0172 10.6839C13.2253 10.7186 13.4229 10.789 13.6047 10.8952C13.631 10.9109 13.6489 10.9362 13.6531 10.9656L14.0588 13.5228C14.064 13.5522 14.0546 13.5827 14.0346 13.6048C13.8107 13.8528 13.5249 14.0315 13.2064 14.1208L13.0529 14.1639L13.1107 14.3121C13.6342 15.6449 14.6999 16.7096 16.0337 17.2351L16.1819 17.2939L16.225 17.1405C16.3143 16.822 16.493 16.5361 16.7411 16.3123C16.7589 16.2955 16.7831 16.287 16.8073 16.287C16.8125 16.287 16.8178 16.287 16.8241 16.2881L19.3813 16.6938C19.4118 16.6991 19.437 16.7159 19.4528 16.7421C19.5579 16.924 19.6283 17.1226 19.664 17.3307C19.6808 17.4232 19.6882 17.521 19.6882 17.6229C19.6882 18.5951 18.8968 19.3866 17.9235 19.3876Z"
          fill="var(--icon-fg)"
        />
        <path
          d="M24.7322 14.1576C24.5251 11.818 23.453 9.64759 21.7136 8.04685C19.9636 6.43664 17.6933 5.54956 15.319 5.54956C10.1079 5.54956 5.868 9.78948 5.868 15.0006C5.868 16.7495 6.35042 18.4533 7.26378 19.9373L5.22685 24.4463L11.7486 23.7516C12.8827 24.2161 14.083 24.4516 15.3179 24.4516C15.6427 24.4516 15.9759 24.4347 16.3101 24.4001C16.6044 24.3685 16.9019 24.3223 17.1941 24.2634C21.558 23.3816 24.7437 19.5085 24.7689 15.051V15.0006C24.7689 14.7168 24.7563 14.433 24.7311 14.1587L24.7322 14.1576ZM11.9998 21.7724L8.39156 22.1571L9.46888 19.7702L9.25341 19.4812C9.23765 19.4602 9.22189 19.4391 9.20402 19.415C8.26859 18.1232 7.77459 16.5971 7.77459 15.0016C7.77459 10.8416 11.159 7.45721 15.319 7.45721C19.2163 7.45721 22.5197 10.4979 22.8382 14.3794C22.855 14.5875 22.8645 14.7967 22.8645 15.0027C22.8645 15.0615 22.8634 15.1193 22.8624 15.1813C22.7825 18.6614 20.3514 21.6169 16.9502 22.3694C16.6906 22.4273 16.4247 22.4714 16.1598 22.4998C15.8845 22.5313 15.6017 22.5471 15.3211 22.5471C14.3216 22.5471 13.3504 22.3537 12.4328 21.9711C12.3309 21.9301 12.231 21.886 12.1375 21.8408L12.0008 21.7746L11.9998 21.7724Z"
          fill="var(--icon-fg)"
        />
      </svg>
    </IconWrapper>
  );
};

export const YouTubeIcon = () => {
  return (
    <IconWrapper>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M30 15C30 6.71573 23.2843 0 15 0C6.71574 0 0 6.71573 0 15C0 23.2843 6.71574 30 15 30C23.2843 30 30 23.2843 30 15Z"
          fill="var(--icon-bg)"
        />
        <path
          d="M24.4452 11.8918C24.3272 10.7523 24.0732 9.49277 23.1382 8.83083C22.4141 8.31752 21.4623 8.29854 20.5738 8.2996C18.6955 8.2996 16.8161 8.30276 14.9378 8.30382C13.1312 8.30592 11.3246 8.30698 9.51796 8.30909C8.76327 8.30909 8.02966 8.25111 7.32873 8.57786C6.72687 8.85824 6.25572 9.39158 5.97218 9.98501C5.57902 10.8103 5.49681 11.7452 5.44938 12.658C5.3619 14.3203 5.37138 15.9867 5.47573 17.6479C5.55268 18.86 5.74767 20.1997 6.68471 20.9723C7.51529 21.6564 8.68738 21.6901 9.76461 21.6911C13.1839 21.6943 16.6043 21.6975 20.0246 21.6996C20.4631 21.7006 20.9205 21.6922 21.3675 21.6437C22.2465 21.5488 23.0845 21.2969 23.6494 20.6455C24.2197 19.9889 24.3662 19.075 24.4526 18.2097C24.6634 16.11 24.6613 13.9903 24.4452 11.8918ZM12.9605 17.943V12.0562L18.0578 14.9991L12.9605 17.943Z"
          fill="var(--icon-fg)"
        />
      </svg>
    </IconWrapper>
  );
};

export const EarIcon = () => {
  return (
    <IconWrapper>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z"
          fill="var(--icon-bg)"
        />
        <path
          d="M19.8546 14.1151C22.5441 15.2471 23.8674 17.9566 22.9898 20.7607C22.3918 22.6745 20.6881 24.2206 18.8625 24.9195C16.5608 25.8034 13.4697 25.7466 11.1995 24.8049C6.59507 22.8974 5.52094 17.6003 5.97813 13.1934C6.29659 10.1087 7.58092 7.10174 10.4165 5.5557C12.5532 4.38593 15.288 4.21986 17.6275 4.70963C20.0564 5.21832 22.0281 6.65506 23.2231 8.83065C23.592 9.49804 23.8905 10.2358 24.1133 11.0567C24.1196 11.0882 24.107 11.1208 24.0755 11.1271L22.3844 11.5727C22.3529 11.579 22.3203 11.5601 22.314 11.5349C22.0596 10.568 21.6592 9.70929 21.1053 8.95992C19.3753 6.60671 16.2024 5.97716 13.4676 6.46693C10.2431 7.04604 8.46271 9.30991 7.94141 12.4188C7.51575 14.9433 7.64923 17.8683 8.8127 20.1963C9.79224 22.1553 11.5663 23.2547 13.7031 23.5605C14.8539 23.7193 15.9796 23.7003 17.08 23.4964C18.6575 23.2042 20.3486 22.1606 21.0349 20.6661C21.4805 19.6991 21.5247 18.4726 21.0349 17.512C20.7553 16.9655 20.3349 16.5261 19.7821 16.1961C19.7569 16.1772 19.718 16.1898 19.7054 16.215C19.6991 16.2213 19.6991 16.2276 19.6991 16.234C19.635 16.7048 19.5278 17.1683 19.368 17.6202C19.1389 18.2624 18.8089 18.8163 18.3695 19.2672C16.8939 20.7869 14.3253 20.9204 12.589 19.8263C11.2027 18.9487 10.6814 17.1557 11.3425 15.6801C12.0288 14.154 13.7083 13.4929 15.3037 13.4162C16.2066 13.3721 17.04 13.4099 17.8094 13.5181C17.8409 13.5245 17.8661 13.4992 17.8734 13.4677V13.4488C17.803 13.0988 17.7211 12.8129 17.6191 12.5901C17.0852 11.414 15.8829 11.1019 14.6815 11.2543C13.9122 11.3499 13.3079 11.7125 12.8559 12.3358C12.837 12.361 12.8055 12.3673 12.7792 12.3484L11.3425 11.3688C11.3173 11.3499 11.311 11.3184 11.3299 11.2858C12.0992 10.2043 13.1418 9.57476 14.465 9.40344C15.5591 9.25735 16.7857 9.42867 17.74 10.0078C19.1704 10.8854 19.6791 12.4629 19.8063 14.0584C19.8189 14.0899 19.8315 14.1088 19.8504 14.1151H19.8546ZM12.9926 16.6081C12.7067 17.5687 13.3678 18.3255 14.2643 18.5535C15.5234 18.872 16.9223 18.5914 17.5203 17.3007C17.7558 16.792 17.8955 16.194 17.9397 15.514C17.9397 15.4825 17.9208 15.4573 17.8955 15.4573C16.9612 15.2733 16.0006 15.2344 15.021 15.3301C14.2265 15.4131 13.2406 15.7757 12.9926 16.6081Z"
          fill="var(--icon-fg)"
        />
      </svg>
    </IconWrapper>
  );
};

export const DiscordIcon = () => {
  return (
    <IconWrapper>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.0341 0H14.9658C6.70043 0 0 6.70044 0 14.9658V15.0342C0 23.2996 6.70043 30 14.9658 30H15.0341C23.2995 30 30 23.2996 30 15.0342V14.9658C30 6.70044 23.2995 0 15.0341 0Z"
          fill="var(--icon-bg)"
        />
        <path
          d="M22.5071 8.11297C21.126 7.47919 19.6462 7.01252 18.098 6.74556C18.0696 6.7403 18.0412 6.75292 18.0275 6.77919C17.8373 7.11763 17.626 7.56012 17.4789 7.90696C15.814 7.65786 14.1576 7.65786 12.5264 7.90696C12.3782 7.55171 12.1596 7.11763 11.9683 6.77919C11.9535 6.75397 11.9252 6.74135 11.8978 6.74556C10.3507 7.01252 8.86979 7.47919 7.48871 8.11297C7.47715 8.11822 7.46664 8.12663 7.45928 8.13819C4.65089 12.334 3.8815 16.4267 4.25883 20.4691C4.26093 20.489 4.27144 20.5079 4.28721 20.5195C6.1402 21.8806 7.93541 22.7067 9.69696 23.2543C9.72534 23.2627 9.75477 23.2522 9.77264 23.2291C10.1888 22.6605 10.5609 22.0603 10.8794 21.4287C10.8983 21.3919 10.8794 21.3477 10.8415 21.333C10.2519 21.1091 9.69169 20.8369 9.15145 20.5279C9.10836 20.5027 9.10522 20.4417 9.14411 20.4123C9.25763 20.3272 9.37113 20.2389 9.47939 20.1495C9.49936 20.1327 9.52668 20.1296 9.5498 20.1401C13.095 21.7587 16.9334 21.7587 20.4365 20.1401C20.4597 20.1285 20.487 20.1327 20.507 20.1485C20.6152 20.2378 20.7287 20.3272 20.8433 20.4123C20.8822 20.4417 20.8801 20.5027 20.837 20.5279C20.2978 20.8432 19.7365 21.1102 19.1459 21.333C19.107 21.3477 19.0901 21.3919 19.1091 21.4297C19.4349 22.0593 19.8059 22.6594 20.2148 23.2291C20.2316 23.2533 20.2621 23.2638 20.2904 23.2554C22.0604 22.7078 23.8556 21.8817 25.7086 20.5206C25.7243 20.509 25.7349 20.4901 25.737 20.4712C26.1889 15.7982 24.9802 11.7391 22.5344 8.1403C22.5281 8.12874 22.5187 8.11928 22.506 8.11402L22.5071 8.11297ZM11.407 18.0075C10.3391 18.0075 9.46048 17.0279 9.46048 15.8245C9.46048 14.621 10.3234 13.6415 11.407 13.6415C12.4906 13.6415 13.3714 14.6305 13.3535 15.8245C13.3535 17.0279 12.4906 18.0075 11.407 18.0075ZM18.6056 18.0075C17.5377 18.0075 16.6591 17.0279 16.6591 15.8245C16.6591 14.621 17.522 13.6415 18.6056 13.6415C19.6892 13.6415 20.57 14.6305 20.5521 15.8245C20.5521 17.0279 19.6987 18.0075 18.6056 18.0075Z"
          fill="var(--icon-fg)"
        />
      </svg>
    </IconWrapper>
  );
};

export const GhostIcon = () => {
  return (
    <IconWrapper>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.0342 0H14.9658C6.70044 0 0 6.70044 0 14.9658V15.0342C0 23.2996 6.70044 30 14.9658 30H15.0342C23.2996 30 30 23.2996 30 15.0342V14.9658C30 6.70044 23.2996 0 15.0342 0Z"
          fill="var(--icon-bg)"
        />
        <path
          d="M19.6934 12.254C19.6913 12.4548 19.6703 12.6555 19.6514 12.8563C19.6451 12.9225 19.643 12.9898 19.6419 13.056C19.6398 13.1705 19.7313 13.2746 19.8458 13.2672C19.9005 13.2641 19.9562 13.2494 20.0087 13.2315C20.1843 13.1695 20.3577 13.1033 20.5322 13.0371C20.6898 12.9761 20.8506 12.9214 21.0136 12.8773C21.1912 12.8289 21.3688 12.7932 21.5496 12.8226C21.9174 12.8826 22.1571 13.2788 22.0226 13.6267C21.9847 13.7244 21.9269 13.8085 21.8575 13.8863C21.7619 13.9925 21.6536 14.0828 21.5359 14.1627C21.3972 14.2563 21.2574 14.3477 21.1176 14.4402C20.8843 14.5937 20.6509 14.7461 20.4187 14.9016C20.322 14.9657 20.2284 15.034 20.137 15.1045C20.0865 15.1433 20.0392 15.1885 19.9961 15.2358C19.9142 15.3273 19.869 15.4439 19.8763 15.5659C19.8837 15.6951 19.9057 15.8213 19.9415 15.9453C20.0518 16.3321 20.2211 16.6915 20.426 17.0352C20.9757 17.9528 21.7545 18.6696 22.6816 19.255C22.9359 19.4158 23.2081 19.5451 23.4761 19.6839C23.514 19.7038 23.5508 19.7238 23.5876 19.7459C23.6243 19.768 23.6569 19.7974 23.6811 19.8331C23.7189 19.8867 23.7242 19.9435 23.6916 20.0023C23.6643 20.0528 23.6243 20.0917 23.5812 20.1274C23.5329 20.1673 23.4804 20.201 23.4257 20.2315C23.1125 20.4091 22.7762 20.5415 22.4283 20.634C22.2601 20.6792 22.0919 20.7265 21.9248 20.7759C21.8218 20.8064 21.7251 20.8516 21.6295 20.901C21.4687 20.984 21.3772 21.1175 21.3436 21.2909C21.3247 21.3876 21.3131 21.4864 21.2952 21.5831C21.2511 21.828 21.1628 21.9173 20.9232 21.9594C20.8391 21.9741 20.7529 21.9825 20.6678 21.9878C20.4533 21.9993 20.2389 22.0056 20.0245 22.0172C20.0182 22.0172 20.0119 22.0172 20.0066 22.0182C19.15 22.0687 18.3218 22.343 17.5871 22.7866C17.5483 22.8097 17.5094 22.8338 17.4694 22.857C17.172 23.0367 16.8693 23.208 16.5445 23.3342C16.1819 23.475 15.8077 23.5591 15.4199 23.5938C15.093 23.6232 14.7672 23.619 14.4424 23.5822C13.9558 23.5275 13.4944 23.3857 13.0582 23.1628C12.8553 23.0588 12.6598 22.9432 12.4664 22.8244C12.4559 22.8181 12.4454 22.8118 12.4339 22.8044C11.6624 22.3346 10.7848 22.0498 9.88192 22.013C9.87562 22.013 9.86932 22.013 9.86301 22.013C9.67382 22.0056 9.48569 21.9983 9.2965 21.9867C9.18614 21.9804 9.07578 21.9657 8.96752 21.9363C8.82983 21.8984 8.72998 21.7775 8.70371 21.6378C8.68899 21.561 8.67743 21.4843 8.66377 21.4076C8.66061 21.3908 8.66061 21.3729 8.65745 21.3561C8.62592 21.1312 8.51451 20.9661 8.30325 20.8705C8.17397 20.8116 8.04155 20.7643 7.90491 20.7265C7.66948 20.6613 7.43194 20.6035 7.20176 20.5205C6.99891 20.448 6.80342 20.3618 6.61528 20.2588C6.55852 20.2283 6.50386 20.1936 6.45131 20.1579C6.41557 20.1337 6.38195 20.1064 6.35252 20.0759C6.25792 19.9771 6.26738 19.8478 6.37459 19.7638C6.4366 19.7144 6.50911 19.6818 6.57953 19.6471C7.07037 19.4064 7.536 19.1247 7.96903 18.7905C8.62278 18.287 9.17668 17.6911 9.59604 16.9732C9.74529 16.7168 9.86931 16.4445 9.97126 16.165C10.0385 15.98 10.0932 15.795 10.1068 15.6006C10.1163 15.4576 10.068 15.3157 9.97021 15.2117C9.89979 15.137 9.81781 15.0771 9.73477 15.0172C9.61075 14.9289 9.48568 14.8417 9.35956 14.7587C9.08839 14.58 8.81617 14.4045 8.545 14.2268C8.42623 14.1491 8.31166 14.065 8.20865 13.9672C8.13403 13.8958 8.06676 13.819 8.01316 13.7297C7.90175 13.5426 7.89334 13.3503 7.97638 13.1527C8.02578 13.035 8.11828 12.9351 8.23389 12.8815C8.39891 12.8058 8.57128 12.7964 8.7447 12.8247C8.93178 12.8552 9.11151 12.913 9.28913 12.9771C9.47096 13.0423 9.64964 13.1138 9.83042 13.1811C9.91451 13.2126 9.99964 13.2441 10.089 13.2578C10.11 13.2609 10.131 13.2672 10.152 13.2662C10.2561 13.263 10.3423 13.2294 10.3412 13.0896C10.3412 13.0223 10.3391 12.954 10.336 12.8868C10.3202 12.5504 10.3002 12.2141 10.2918 11.8778C10.2729 11.0769 10.2761 10.2728 10.4852 9.49503C10.6135 9.0189 10.8352 8.57642 11.1348 8.18332C11.7559 7.36666 12.5757 6.8485 13.5564 6.57208C14.0924 6.42073 14.64 6.37133 15.195 6.38814C15.7194 6.40391 16.2418 6.4922 16.7379 6.66562C17.3265 6.87163 17.8615 7.17012 18.3166 7.59369C18.8337 8.07507 19.232 8.63738 19.4485 9.31846C19.5463 9.62642 19.6083 9.94173 19.6461 10.2612C19.725 10.9224 19.7029 11.5877 19.6966 12.2519L19.6934 12.254Z"
          fill="var(--icon-fg)"
        />
      </svg>
    </IconWrapper>
  );
};

export const ColorThemeIcon = () => {
  return (
    <IconWrapper>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="24" height="24" rx="6" fill="var(--icon-bg)" />
        <path
          d="M18.1986 13.1309C17.3166 13.7908 16.2711 14.1437 15.1669 14.1437C12.4226 14.1437 10.1945 11.9417 10.1945 9.2432C10.1945 7.83839 10.8087 6.49893 11.8737 5.5711C11.9783 5.47963 12.011 5.32934 11.9652 5.2052C11.9129 5.07452 11.8084 4.98304 11.6451 5.00265C7.91415 5.15946 5 8.17163 5 11.8568C5 15.542 8.11671 18.7175 11.9522 18.7175C15.1734 18.7175 17.9569 16.5613 18.7083 13.4641C18.741 13.3269 18.6887 13.1897 18.5711 13.1113C18.4535 13.0329 18.3032 13.0394 18.1921 13.1244L18.1986 13.1309Z"
          fill="var(--icon-fg)"
        />
      </svg>
    </IconWrapper>
  );
};
